<template>
<div v-if="display != null" style="margin-top: 30px; margin-bottom: 30px">
    <div class="loader d-flex justify-content-center" v-if="this.loading">
      <b-spinner :label="$t('common_phrases.loading')"></b-spinner>
    </div>
    <div v-if="this.organParams != null">
      <b-row v-for="param in this.organParams" :key="param.id">
          <b-col>{{ $t(param.descriptionId) }}</b-col>
          <b-col>{{ attribValue(param.name) }}</b-col>
      </b-row>
    </div>
</div>
</template>

<script>
//import moment from 'moment';
import device from '@/store/displays/device'

export default {
    name: "DeviceOrganizationParameters",
    props: ['display'],
    data: function() {
      return { 
        loading: true,
        organParams: null,
        organisaatio: null
      }
    },
    computed: { },
    mounted: function() {
      this.organisaatio = this.$props.display.organisaatio;
      if(this.$store.state.device){
        if(this.organisaatio == null) {
          this.organParams = {};
          this.loading = false;
          return;
        }
        this.$store.dispatch('device/getOrganizationDeviceParameters', this.organisaatio).then((data) =>{
          this.organParams = data;
          this.loading = false;
        });
      }
    },
    beforeCreate: function() {
        if (!this.$store.state.device) {
             this.$store.registerModule("device", device);
        }
    },
    methods: {
      /*formatTimestamp(ts){
        var time = "";
        try {
          time = new moment(ts, 'YYYY-MM-DD[T]HH:mm:ssZZ').format('DD.MM.YYYY HH:mm:ss');
          if (time.startsWith('Invalid')) time = "";
        } catch(err) {
          time = ""
        }
        return time;
      },*/
      attribValue: function(paramName) {
        var item = this.$props.display.attributes.find((i) => {
          return i.name == paramName;
        });
        if(item == undefined)
          return "";

        if(item.name == "DOUBLE_SIDED")
          return this.$t("sse_displays.status_info.values." + item.value)
        
        return item.value;
      }
    },
}

</script>

<style scoped lang="scss">
.row {
    font-size: 0.75rem;
    white-space: pre-wrap;
    margin-bottom: 5px;
}
.col {
    border-bottom: 1px solid #cecece;
}

.col:first-child {
    font-weight: bold;
}


</style>
